import emptySplitApi from "../utils/rtk";
 
import { END_POINTS } from "../helpers";
import { CommonBody } from "../types/General";

type CommonResponseType = {
  statusCode: number;
  message: string;
   s3Location?:string
};

type PostLoginBody = {
  email: string;
  password: string;
};
type queryUser={
  page:number,
  search:string
}
 
interface CategoryResponse extends CommonResponseType {
  data: any;
}

interface QueryParams {
  userId?: any;
}

export const authApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    postAddBanner: builder.mutation<
      CommonResponseType & { data: any },
      CommonBody
    >({
      query: (body) => ({
        url: END_POINTS.banner,
        method: "POST",
        body,
      }),
    }),
    getAllBanner: builder.query<CommonResponseType & { data: any }, { page?: number; search?: string;limit:number }>({
      query: ({ page, search ,limit}) => {
        let url = `${END_POINTS.banner}?page=${page}&search=${search}&limit=${limit}`;
        // let url = END_POINTS.banner;
        // url+="?limit=10";
        // if (page && search) {
        //   url += `&page=${page}&search=${search}`;
        // } else if (page) {
        //   url += `&page=${page}`;
        // } else if (search) {
        //   url += `&search=${search}`;
        // }
       
        return {
          url: url,
          method: "GET",
        };
      },
    }),
    
    
    getSpecificBannerById: builder.query<CategoryResponse, QueryParams>({
      query: ({ userId }) => ({
        url: `${END_POINTS.banner}/${userId}`,
        method: 'GET',
      }),
    }),
   
  
    EditBanner: builder.mutation<
    CommonResponseType & { data: CommonBody },
    { id: string | undefined; body: CommonBody }
  >({
    query: ({ body, id }) => ({
      url: `${END_POINTS.banner}/${id}`,
      method: "PUT",
      body,
    }),
  }),
  
    
      
    deleteByIdBanner:  builder.query<CommonResponseType & { data: any }, { userId: any}>({
        query: ({ userId }) => ({
          url: `${END_POINTS.banner}/${userId}`,
          method: "DELETE",
        }),
      }),
 
  }),
});

export const {
    usePostAddBannerMutation,
    useLazyGetAllBannerQuery,
    useLazyGetSpecificBannerByIdQuery,
    useEditBannerMutation,
    useLazyDeleteByIdBannerQuery,
   
} = authApi;
